import {CSSProperties, FC} from 'react';


export interface IIconYoutubeProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconYoutube: FC<IIconYoutubeProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M11.97 0c6.61 0 11.969 5.359 11.969 11.97 0 6.61-5.36 11.969-11.97 11.969S0 18.579 0 11.969 5.359 0 11.97 0Zm.717 10.572h-1.431c-1.432.003-2.866.026-4.285.185-.7.078-1.28.602-1.443 1.312-.233 1.011-.236 2.115-.236 3.157 0 1.04 0 2.145.233 3.156.163.71.744 1.234 1.443 1.312 1.656.185 3.332.186 5 .185h.716c1.432-.003 2.866-.026 4.286-.185.699-.078 1.28-.602 1.443-1.312.233-1.01.234-2.115.234-3.156v-.394c-.003-.922-.028-1.878-.23-2.763a1.688 1.688 0 0 0-1.445-1.312c-1.656-.185-3.332-.186-5-.185h.715Zm.358 1.44v1.952c.26-.321.537-.483.834-.483.321 0 .538.169.645.503.054.179.082.473.082.895v1.773c0 .412-.028.71-.082.898-.108.331-.324.5-.645.5-.287 0-.564-.16-.834-.492v.431h-.807v-5.978h.807Zm-3.02 1.523v3.382c.001.123.002.19.008.21.02.126.081.19.189.19.162 0 .331-.125.51-.378v-3.404h.808v4.454h-.808v-.486c-.32.368-.625.547-.922.547-.26 0-.439-.105-.52-.331-.044-.135-.071-.348-.071-.663v-3.521h.807Zm6.425-.054c.405 0 .726.152.951.456.17.225.25.573.25 1.049v.923h-1.614v.79c0 .411.136.617.413.617.198 0 .315-.107.36-.323.008-.044.018-.224.018-.547h.823v.117c0 .26-.01.44-.017.52a1.15 1.15 0 0 1-.188.484c-.224.324-.555.483-.976.483-.422 0-.744-.152-.977-.456-.172-.223-.26-.574-.26-1.047v-1.56c0-.476.079-.825.25-1.05.233-.305.554-.456.967-.456ZM9.1 12.01v.842h-.966v5.136h-.898v-5.136h-.949v-.841h2.813Zm4.346 2.196c-.132 0-.267.063-.402.196v2.715c.135.135.27.199.402.199.234 0 .352-.199.352-.602v-1.9c0-.402-.119-.608-.352-.608Zm2.995 0c-.27 0-.405.206-.405.618v.412h.808v-.412c0-.412-.136-.618-.403-.618Zm-2.328-8.609h-.813v3.56c0 .317.027.533.072.669.082.228.263.334.525.334.298 0 .608-.18.932-.552v.49h.816V5.6h-.816v3.44c-.18.255-.352.381-.515.381-.11 0-.173-.064-.191-.19-.01-.027-.01-.126-.01-.318V5.598Zm-2.689-.054c-.406 0-.724.154-.95.462-.173.227-.255.579-.255 1.06v1.576c0 .478.082.834.255 1.059.226.307.544.46.95.46.409 0 .726-.153.952-.46.17-.225.252-.58.252-1.059V7.066c0-.481-.081-.833-.252-1.06-.226-.308-.543-.462-.952-.462ZM8.04 4.059h-.951c.19.56.389 1.123.58 1.683.29.843.47 1.478.553 1.911V10.1h.904V7.653l1.088-3.594h-.915l-.617 2.372L8.04 4.06Zm3.386 2.22c.263 0 .39.207.39.623v1.894c0 .416-.127.624-.39.624s-.39-.208-.39-.624V6.902c0-.416.127-.624.39-.624Z" clipRule="evenodd" />
        </svg>
    );
};
